module.exports = __webpack_public_path__ + "static/media/kevin_johnson.68593e5b.png";